module.exports = __webpack_public_path__ + "static/media/downloadBlack.69d58f7d.svg";